// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PArrowDownOutlinedSvg from "@fishx/icons-svg/es/asn/PArrowDownOutlined";
import FishxIcon from '../components/FishxIcon';

var PArrowDownOutlined = function PArrowDownOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PArrowDownOutlinedSvg
  }));
};

PArrowDownOutlined.displayName = 'PArrowDownOutlined';
export default React.forwardRef(PArrowDownOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PArrowDownOutlined.js
// module id = 3207
// module chunks = 0